import { createSlice } from '@reduxjs/toolkit';
import { PAGE_INDEX, PAGE_SIZE } from '~/utils/constants/common';
import { Device } from '~/utils/interface/device';
import { handleGetDevices } from './deviceThunk';
import _ from 'lodash';
export interface DeviceState {
  devices: Device[];
  selectedDeviceId: number;
  isLoading: boolean;
  needRefreshData: boolean;
  totalItems: number;
  filter: {
    username: string;
    provinceId: string;
    wardId: string;
    status: number | string;
    from: string;
    to: string;
    search: string;
    pageIndex: number;
    pageSize: number;
    sortBy: string;
    sortOrder: 'asc' | 'desc';
  };
}
const initialState: DeviceState = {
  devices: [],
  selectedDeviceId: 0,
  isLoading: false,
  needRefreshData: false,
  totalItems: 0,
  filter: {
    username: '',
    provinceId: '',
    wardId: '',
    status: '',
    from: '',
    to: '',
    search: '',
    pageIndex: PAGE_INDEX,
    pageSize: PAGE_SIZE,
    sortBy: 'created_at',
    sortOrder: 'desc',
  },
};
const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setSelectedDevice: (state, action) => {
      state.selectedDeviceId = action.payload;
    },
    setNeedRefreshData: (state, action) => {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action) {
      state.filter = { ...state.filter, ...action.payload };
    },
    resetFilter: (state) => {
      state.filter = initialState.filter;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetDevices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(handleGetDevices.fulfilled, (state, action) => {
        const payload = action.payload?.result;
        const data = Array.isArray(payload?.data) ? payload.data : [];
        if (!_.isEqual(state.devices, data)) {
          state.devices = data;
        }
        state.totalItems = Number(payload?.total_record ?? 0);
        state.isLoading = false;
        state.needRefreshData = false;
      })
      .addCase(handleGetDevices.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const deviceActions = deviceSlice.actions;

const deviceReducer = deviceSlice.reducer;
export default deviceReducer;
